'use strict';

angular.module('ClinicApp').directive('clinicFinancing', (OCFormUtil) => ({
  scope: {
    allFinancingOptions: '=',
    clinicFinancingOptions: '=',
    editMode: '=',
    onStartEdit: '&',
    onSave: '&',
    onCancel: '&',
  },
  templateUrl: '/views/directives/_clinic-financing.html',
  link: function($scope) {
    const isOfferedByClinic = (financingOption) =>
      $scope.clinicFinancingOptions.some(({ id }) => id === financingOption.id);

    const initialize = () => {
      $scope.isConfigured = $scope.clinicFinancingOptions.length > 0;

      // The catalog order is meaningful — the API sorts it by name, with "Other" last.
      $scope.financingOptions = $scope.allFinancingOptions.map((financingOption) => ({
        ...financingOption,
        isSelected: isOfferedByClinic(financingOption),
      }));
    };

    $scope.$watch('allFinancingOptions', initialize);
    $scope.$watch('clinicFinancingOptions', initialize);

    $scope.isSaveDisabled = () => !!$scope.isSaving;

    $scope.save = () => OCFormUtil.submit($scope, () => $scope.onSave({
      financingOptionIds: $scope.financingOptions
        .filter(({ isSelected }) => isSelected)
        .map(({ id }) => id),
    }));

    $scope.cancel = () => {
      initialize();
      return $scope.onCancel();
    };

    $scope.startEdit = () => {
      return $scope.onStartEdit();
    };
  },
}));
